import type { Game } from '@game/types'
import { useGameType, type Ref, computed, useGamesJackpots } from '#imports'
import { useGameJackpotBindings } from './useGameJackpotBindings'

export const useGameJackpot = (game: Ref<Game | undefined>) => {
    const { isBingo } = useGameType()

    const shouldFetchJackpots = computed(() => {
        if (!game.value) return false
        if (isBingo(game.value.game_type)) return false

        return game.value.has_jackpot
    })

    const jackpotsQuery = useGamesJackpots({ enabled: shouldFetchJackpots })
    const { gamesJackpots } = jackpotsQuery

    return jackpotsQuery.bind(useGameJackpotBindings(game, gamesJackpots))
}
